import makeList from './makeList.js'

let viewFloor = '管理棟2F'

let params = [
  {
    name: 'syowa',
    locations: [
      { description: 'バー',
        file: './data/I18v.JPG',
        rotation: 146.6174251340443,
        link: [
          {
            file: './data/I59a_A.JPG',
            position: [ -2525.741019050466, -494.2374515107669, -4280.690634202204 ],
          },
          {
            file: './data/I18w.JPG',
            position: [ 3792.5237921256594, -255.29632599282385, -3234.896429680067 ],
          },
          {
            file: './data/I18c_2.JPG',
            position: [ 3604.4606239233126, -498.93423411619125, 3417.323598976727 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 496.65924276169267, 201.6414253897551 ],
        },
      },
      { description: '管理棟 娯楽室',
        file: './data/I18w.JPG',
        rotation: -95.30390447901902,
        link: [
          {
            file: './data/I18v.JPG',
            position: [ -4311.70580240211, 811.8484562910232, 2387.7611635750595 ],
          },
          {
            file: './data/I18c_2.JPG',
            position: [ -1086.1088127095434, 479.2356802262816, 4851.691363555655 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 405.3452115812918, 157.0979955456571 ],
        },
      },
      { description: '管理棟２階階段室',
        file: './data/I18c_2.JPG',
        rotation: 224.68215754507548,
        link: [
          {
            file: './data/I18v.JPG',
            position: [ 2004.3312683957304, 1774.2144426854657, -4213.66592952542 ],
          },
          {
            file: './data/I18w.JPG',
            position: [ 3707.130855716055, 1390.5525752564772, -3037.0965224499723 ],
          },
          {
            file: './data/I18g.JPG',
            position: [ 3992.469434616711, 1102.3004888148607, 2790.319330428356 ],
          },
          {
            file: './data/I18m.JPG',
            position: [ -1586.5280587258396, 861.8445358751953, 4656.574632599429 ],
          },
          {
            file: './data/I18a_1.JPG',
            position: [ -2010.0242593783016, -1561.3795302460576, 4298.768393988532 ],
          },
          {
            file: './data/I18d_3.JPG',
            position: [ -4622.860919283439, 1846.3430000031756, 406.07956172626484 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 478.84187082405344, 246.1848552338531 ],
        },
      },
      { description: '手術室',
        file: './data/I18g.JPG',
        rotation: 119.38158966822255,
        link: [
          {
            file: './data/I18c_2.JPG',
            position: [ -3162.454354920972, 402.10890920175274, -3842.7768754277104 ],
          },
          {
            file: './data/I18h.JPG',
            position: [ -3868.9037231571047, 136.93980008295276, 3147.954145998682 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 383.0734966592428, 301.86414253897567 ],
        },
      },
      { description: '手術準備室',
        file: './data/I18h.JPG',
        rotation: -165.58541948775522,
        link: [
          {
            file: './data/I18g.JPG',
            position: [ 2148.578499584157, 395.03218993560307, -4491.547104359627 ],
          },
          {
            file: './data/I18mc.JPG',
            position: [ -3939.5947928618025, -243.63675445619856, -3054.005646545307 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 461.0244988864142, 355.3162583518932 ],
        },
      },
      { description: '機材・薬品庫',
        file: './data/I18mc.JPG',
        rotation: -8.155630579384225,
        link: [
          {
            file: './data/I18h.JPG',
            position: [ 3658.5707811833877, 717.9901811099496, -3326.5972482568786 ],
          },
          {
            file: './data/I18m.JPG',
            position: [ -4781.960967708772, 1102.9806934944716, -926.0187453132472 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 556.7928730512249, 388.7238307349668 ],
        },
      },
      { description: 'X線撮影操作室',
        file: './data/I18mb.JPG',
        rotation: 65.27915005495142,
        link: [
          {
            file: './data/I18f.JPG',
            position: [ -1611.7923592584073, 1476.2189487301112, 4488.682944304111 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 643.652561247216, 172.68819599109145 ],
        },
      },
      { description: '歯科室',
        file: './data/I18f.JPG',
        rotation: -147.64105184600146,
        link: [
          {
            file: './data/I18m.JPG',
            position: [ 1835.6681761448028, 724.8023103506281, 4585.1540937455475 ],
          },
          {
            file: './data/I18t.JPG',
            position: [ 2220.851772268253, 2309.8903167453946, -3835.8672184130137 ],
          },
          {
            file: './data/I18mb.JPG',
            position: [ -990.8968864901705, 1409.6958368124922, -4689.623525427163 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 657.0155902004454, 277.36525612472167 ],
        },
      },
      { description: '診療室・入院室',
        file: './data/I18m.JPG',
        rotation: -112.04154591658676,
        link: [
          {
            file: './data/I18mc.JPG',
            position: [ 2979.1096624583465, 650.7936724375201, 3953.424133702483 ],
          },
          {
            file: './data/I18c_2.JPG',
            position: [ 4985.795171582344, 343.18643494555, 13.753589991738485 ],
          },
          {
            file: './data/I18f.JPG',
            position: [ -949.6154624992473, 116.42661584785472, -4900.358388373287 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 652.5612472160357, 350.86191536748345 ],
        },
      },
      { description: '病院トイレ',
        file: './data/I18t.JPG',
        rotation: 66.00596624421455,
        link: [
          {
            file: './data/I18f.JPG',
            position: [ -3161.2756378594995, 1307.7607683571307, 3636.5767668505787 ],
          },
        ],
        info: [
        ],
        view: {
          syowa: [ 551.7241379310345, 446.9987228607918 ],
          syowaZoom: [ 612.4721603563474, 221.68596881959922 ],
        },
      },
    ],
  },
]

export default makeList(params,viewFloor)
